module.exports = __webpack_public_path__ + "static/tourasia-logo-de-57891945ee4195d215a5e081e88fd752.png";